import { FormRegistrazione } from "./form";
import "./index.css";

import logo from "./logo.svg";
import reactLogo from "./react.svg";

export function App() {
  return (
    <div className="app">
      <h1>Registra PassKey</h1>
      <FormRegistrazione />
    </div>
  );
}

export default App;
